import Swiper from 'swiper'
import { SwiperContainer } from 'swiper/element'
import { Navigation, Pagination } from 'swiper/modules'

export function handleMainSlider() {
	const slider = document.querySelector<HTMLDivElement>(
		'.product-bundle-slider'
	)
	const bundleSliders = document.querySelectorAll<HTMLDivElement>(
		'.bundle-inner-slider'
	)
	const equipmentSliders = document.querySelectorAll<HTMLDivElement>(
		'.equipment-list-slider'
	)

	if (slider) {
		new Swiper(slider, {
			centeredSlides: true,
			initialSlide: 1,
			slidesPerView: 1.1,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
					centeredSlides: false,
				},
			},
			modules: [Navigation, Pagination],
			navigation: {
				prevEl: slider.querySelector<HTMLElement>(
					'.product-bundle-slider-controls .swiper-button-prev'
				),
				nextEl: slider.querySelector<HTMLElement>(
					'.product-bundle-slider-controls .swiper-button-next'
				),
			},
			pagination: {
				clickable: true,
				el: slider.querySelector<HTMLElement>('.product-bundle-slider-controls .swiper-pagination'),
			},
			on: {
				touchStart(swiper, event) {
					// This is not necessary on larger screens where all slides are shown.
					if (document.documentElement.clientWidth >= 1024) return

					const touch = event instanceof TouchEvent ? event.touches[0] : event as PointerEvent

					// Check each slide — if the touch originated in a partially-clipped slide, 
					// allow the outer swiper to take over instead of the inner one.
					swiper.slides.forEach((slide) => {
						const rect = slide.getBoundingClientRect()
						const containerRect = swiper.el.getBoundingClientRect()
						const isFullyVisible =
							rect.left >= containerRect.left &&
							rect.right <= containerRect.right

						const touchX = touch.clientX
						const touchIsOnThisSlide =
							touchX >= rect.left && touchX <= rect.right
						
						const innerSwiper = slide.querySelector<SwiperContainer>('.bundle-inner-slider')?.swiper

						if (!innerSwiper) return
						innerSwiper.allowTouchMove = !(touchIsOnThisSlide && !isFullyVisible)
					})
				},
			},
		})
	}

	bundleSliders?.forEach((slider) => {
		new Swiper(slider, {
			modules: [Navigation, Pagination],
			
			slidesPerView: 1,
			spaceBetween: 0,
			nested: true,
			touchReleaseOnEdges: true,
			navigation: {
				prevEl: slider.querySelector<HTMLElement>(
					'.swiper-navigate-prev'
				),
				nextEl: slider.querySelector<HTMLElement>(
					'.swiper-navigate-next'
				),
			},
			pagination: {
				clickable: true,
				el: slider.querySelector<HTMLElement>('.swiper-pagination'),
			},
		})
	})

	equipmentSliders?.forEach((slider:HTMLElement) => {
		new Swiper(slider, {
			modules: [Navigation],

			slidesPerView: 6,
			spaceBetween: 5,
			touchReleaseOnEdges: true,
			navigation: {
				prevEl: slider.querySelector<HTMLElement>(
					'.swiper-navigate-prev'
				),
				nextEl: slider.querySelector<HTMLElement>(
					'.swiper-navigate-next'
				),
			},
			on: {
				slideChange: (swiper) => {
					swiper.el.classList.toggle('swiper-reached-end', swiper.isEnd)	
				} 
			}
		})
	})
}

export function handleBundle() {
	const upateTextToBundleTitle = (
		titleEl: HTMLElement,
		titleText: string
	) => {
		titleEl.textContent = titleText
	}

	const getBundleNameFromItem = (item: HTMLElement) => {
		if (!item) return
		return item.dataset.productTitle
	}

	const setActiveStateToCurrentBundleItem = (
		container: HTMLElement,
		target: HTMLElement
	) => {
		container.querySelectorAll('.equipment__item ').forEach((item) => {
			item.classList.remove('is-active')
		})

		target.classList.add('is-active')
	}

	const isBundleContainer = (target: HTMLElement) => {
		return (
			target.closest('.card__bundle-equipment') ||
			target.classList.contains('card__bundle-equipment') ||
			target.closest('.equipment__list') !== null
		)
	}


	// Initialize active state for all equipment lists
	document.querySelectorAll('.equipment__list').forEach((list) => {
		if (!list.querySelector('.equipment__item.is-active')) {
			list.querySelector('.equipment__item')?.classList.add('is-active')
		}
	})

	const handleBundleInteraction = (e: Event) => {
		const target = e.target as HTMLElement
		if (!target || !isBundleContainer(target)) return

		const item = target.closest('.equipment__item') as HTMLElement | null
		if (!item) return

		e.preventDefault()

		const bundleContainer = item.closest(
			'.card__bundle-equipment'
		) as HTMLElement
		const bundleDisplayNameEl = bundleContainer.querySelector(
			'.equipment__item-title'
		) as HTMLElement

		const bundleTitle = getBundleNameFromItem(item)
		if (bundleTitle) {
			upateTextToBundleTitle(bundleDisplayNameEl, bundleTitle)
		}
		setActiveStateToCurrentBundleItem(bundleContainer, item)
	}

	document.addEventListener('click', handleBundleInteraction)
	document.addEventListener('touchend', handleBundleInteraction);
	document.addEventListener('mouseover', handleBundleInteraction);


	const handleTabEquipmentHover = (e: Event) => {
		const target = e.target as HTMLElement
		const item = target.closest('.equipment__item') as HTMLElement | null
		if (!item) return
		if (!item.closest('.tab__section')) return
		const list = item.closest('.equipment__list') as HTMLElement | null
		if (!list) return

		list.querySelectorAll('.equipment__item').forEach((el) => {
			el.classList.remove('is-active')
		})
		item.classList.add('is-active')
	}

	document.addEventListener('mouseover', handleTabEquipmentHover)
	document.addEventListener('touchend', handleTabEquipmentHover)
	document.addEventListener('click', handleTabEquipmentHover)
}
